import React from 'react'

function Error() {
  return (
    <div className='w-full h-[calc(100vh-3.5rem)] bg-richblack-900 flex items-center justify-center text-3xl text-white'>
        Error 404 - Not Found
    </div>
  )
}

export default Error